import type { DriveStep } from 'driver.js';
import { defineStore } from 'pinia';
import { useTourStore } from './tourStore';

export const useOfficeProfileSettingsTourStore = defineStore('officeProfileSettingsTour', () => {
  const tourStore = useTourStore();

  const officeProfileSettingsTourSteps: DriveStep[] = [
    {
      element: '[data-cy="office-locations-subscriptions"]',
      popover: {
        title: 'Praxis-Profil',
        description:
          'Hier verwaltest du deine Standorte. Pro Standort kannst du Praxis-News, Anschrift, Öffnungszeiten und Praxis-Materialien hinterlegen, die dem Patienten die Anmeldung erleichtern und dir Zeit sparen!',
        side: 'bottom',
        onNextClick: () => {
          tourStore.setTourToComplete();
          tourStore.driverObject?.moveNext();
        },
      },
    },
    {
      element: '[data-cy="generic-table-item-0"]',
      popover: {
        title: 'Standort öffnen',
        description:
          '<span class="font-bold">Klicke auf einen Standort,</span> um Praxis-News, Anschrift, Öffnungszeiten und Materialien zu bearbeiten.',
        side: 'bottom',
        nextBtnText: `<span class="opacity-50">Weiter →</span>`,
        onPopoverRender: async () => {
          // Wait for the sidebar DOM to render before moving on, otherwise
          // the next step's popover wanders looking for an element that
          // doesn't exist yet.
          const element = document.querySelector('[data-cy="generic-table-item-0"]');
          if (element) {
            element.addEventListener(
              'click',
              async () => {
                await new Promise((resolve) => setTimeout(resolve, 600));
                tourStore.driverObject?.moveNext();
              },
              { once: true },
            );
          }
        },
        onNextClick: () => {},
      },
    },
    // The standort detail now lives in the "Profil" tab of the
    // officeLocationSettings panel. Each block is a `GenericFoldOutContent`, and
    // its `id` is a declared prop — it never reaches the DOM as an id attribute,
    // only as the `data-cy` the component builds from it. Highlight the foldout
    // box itself; the steps follow the order the blocks appear in the tab.
    {
      element: '[data-cy="genericFoldOutContent-office-profil"]',
      popover: {
        title: 'Profil',
        description:
          'Hinterlege hier den Namen, das Banner und die Stammdaten deines Standorts. Diese Angaben sehen deine Patient:innen.',
        side: 'left',
      },
    },
    {
      element: '[data-cy="genericFoldOutContent-office-anschrift"]',
      popover: {
        title: 'Anschrift',
        description:
          'Hier pflegst du die Standortanschrift sowie optional eine separate Rechnungsanschrift.',
        side: 'left',
      },
    },
    {
      element: '[data-cy="genericFoldOutContent-office-oeffnungszeiten"]',
      popover: {
        title: 'Öffnungszeiten',
        description:
          'Lege die Öffnungszeiten je Wochentag fest – deine Patient:innen sehen diese im Praxis-Profil.',
        side: 'left',
      },
    },
    {
      element: '[data-cy="genericFoldOutContent-office-news"]',
      popover: {
        title: 'Praxisnews',
        description:
          'Teile deinen Patienten News, Ankündigungen oder Informationen deiner Wahl mit!',
        side: 'left',
      },
    },
  ] as const;
  return {
    officeProfileSettingsTourSteps,
  };
});
